export default "__VITE_ASSET__$yTYudKb__"